<template>
    <admin-header />
    <admin-menu />
    <div class="flex sm:ml-20 mt-6 dark:text-dark.textOnBkg">
        <font-awesome-icon icon="fas fa-arrow-left" class="text-2xl mr-6 cursor-pointer mt-5" @click="$router.go(-1)" />
        <div>
            <MazSelect 
                v-model="selectedCompany"
                :options="companies_list"
                size="sm"
                label="Agency"
                optionValueKey="id"
                optionLabelKey="name"
                option-input-value-key="name"
                search
            /><br />
            <div class="cursor-pointer mt-1.5" @click="onlyActiveFunction">
                <div>
                    <font-awesome-icon :icon="onlyActive.icon" /> Show only active
                </div>
            </div>
        </div>
    </div>
    <div class="overflow-x-auto mx-auto mt-2 px-5 sm:pl-20 sm:pr-10">
        <div class="overflow-auto pb-20" style="height: calc(100vh - 155px);">
            <table
                class="bg-transparent dark:bg-dark.tableBG mt-3 mx-auto whitespace-nowrap rounded font-normal border border-sepBorder dark:border-dark.sepBorder table-auto w-full">
                <thead>
                    <tr class="top-0 sticky bg-gray-100 z-10 border border-sepBorder dark:bg-dark.panels dark:text-dark.textOnBkg">
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">ID</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Avatar</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Platform</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Name</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Assignment</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Active</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Active sessions</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Scraped days</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Last scrape</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Code</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Added at</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Proxy</th>
                        <th class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody v-if="filteredCreators.length > 0">
                    <slot v-for="(creator, index) in filteredCreators" :key="index">
                        <tr class="dark:bg-dark.tableBG dark:text-dark.textOnBkg" :class="{'bg-gray-100 dark:bg-dark.tableRow1': index%2 == 1}">
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ creator.id }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <div class="rounded-full h-12 w-12 mx-auto shadow bg-gray-200" :style="{ backgroundImage: creator?.avatar ? `url(${creator?.avatar})` : '', backgroundSize: 'cover', backgroundPosition: 'center'}"></div>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <div class="w-20 mx-auto">
                                    <img :src="$platformLogo(creator)" :title="creator?.platformName" :alt="creator?.platformName" class="h-5 mx-auto"/>
                                </div>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ creator.name }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <span v-if="creator.assignment">{{ creator.assignment }}</span>
                                <span v-else>Not assigned</span>
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <font-awesome-icon v-if="creator.active" icon="fas fa-check" class="text-green-500" />
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{creator.sessionCount}}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{creator.stats_count}}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{creator.last_update ?? 'Not scraped yet'}}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ creator.code }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">{{ $moment(creator.addedAt).format("DD.MM.YYYY HH:MM") }}</td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <font-awesome-icon 
                                    :icon="['fas', creator.on_proxy ? 'check' : 'times']" 
                                    :class="creator.on_proxy ? 'text-green-500' : 'text-red-500'" 
                                />
                            </td>
                            <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center">
                                <div class="flex items-center">
                                    <font-awesome-icon :icon="['fas', 'download']" class="cursor-pointer" @click="openScraping(creator)" />
                                </div>
                            </td>
                        </tr>
                    </slot>
                </tbody>
                <tbody v-else-if="!loading">
                    <tr>
                        <td class="border border-sepBorder dark:border-dark.sepBorder p-2 text-center" colspan="11">
                            <span v-if="!selectedCompany">Please select a company first</span>
                            <span v-else>No creators found</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7" class="text-center py-16 dark:text-dark.textOnBkg">
                            <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-xl text-center" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <MazDialog
        v-model="isScrapingDialogVisible"
        :title="'Scraping details'"
        size="lg"
        :esc-close="true"
        :overlay-close="true"
    >
        <template #default>
            <scraping-details :model="selectedCreator" />
        </template>
    </MazDialog>
</template>

<script setup>
    import adminHeader from '@/components/admin/AdminHeader.vue';
    import adminMenu from '@/components/admin/AdminMenu.vue';
    import MazDialog from 'maz-ui/components/MazDialog';
    import scrapingDetails from '@/components/admin/creatorScraping.vue';
</script>
  
<script>
    import { getCreators, getCompanies } from '@/api/admin_api';
    export default {
        name: 'CreatorsDashboard',
        data() {
            return {
                creators_list: [],
                selectedCompany: 0,
                onlyActive: {
                    icon: 'fas fa-square-check',
                    active: true
                },
                loading: false,
                companies_list: [],
                isScrapingDialogVisible: false, // Added for dialog visibility
                selectedCreator: null // Added to store the selected creator
            }
        },
        computed: {
            filteredCreators() {
                if (this.onlyActive.active) {
                    return this.creators_list.filter(creator => creator.active);
                }
                return this.creators_list;
            }
        },
        watch: {
            selectedCompany: function() {
                this.getCreators_list();
            },
        },
        methods: {
            openScraping(creator) {
                this.selectedCreator = creator; // Set the selected creator
                this.isScrapingDialogVisible = true; // Open the dialog
            },
            onlyActiveFunction() {
                this.onlyActive.active = !this.onlyActive.active;
                this.onlyActive.icon = this.onlyActive.active ? 'fas fa-check-square' : 'far fa-square';
            },
            isTrialPeriod(trialEndDate) {
                return this.$moment(trialEndDate).isSameOrAfter(this.$moment());
            },
            async getCreators_list() {
                this.loading = true;
                if (!this.selectedCompany) { return; }
                await getCreators(this.$cookies.get('admin_auth_token'), this.selectedCompany).then((response) => {
                    this.creators_list = response;
                    this.loading = false;
                });
            },
        },
        created() {
            this.loading = true;
            getCompanies(this.$cookies.get('admin_auth_token')).then((response) => {
                this.companies_list = response;
                this.loading = false;
            });

            if (this.$route.query.company) {
                this.selectedCompany = parseInt(this.$route.query.company);
                this.getCreators_list();
            }
        }
    };
</script>